const withRenderedMain = require('components-framework/view/with_rendered_main');
module.exports = withRenderedMain(Backbone.View.extend(Odigeo._.extend({
    initialize(options) {
        this.updateSeatTypes(options.seatAvailabilityByType);
    },
}, require('./view'))));
